(function($) {
    'use strict';

    $(document).ready(function() {
        var $slider = $('.about-team__grid');
        if (!$slider.length) return;

        var slickInitialized = false;

        function initTeamSlider() {
            var windowWidth = window.innerWidth;

            if (windowWidth <= 991) {
                if (!slickInitialized) {
                    $slider.slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 4000,
                        dots: true,
                        arrows: false,
                        responsive: [
                            {
                                breakpoint: 576,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    });
                    slickInitialized = true;
                }
            } else {
                if (slickInitialized) {
                    $slider.slick('unslick');
                    slickInitialized = false;
                }
            }
        }

        // Run on load and resize
        initTeamSlider();
        $(window).on('resize', function() {
            initTeamSlider();
        });
    });

})(jQuery);
